
  import {Component, Vue} from 'vue-property-decorator';
  import AppSwitch from "@/components/AppSwitch.vue";
  import {IAntiTheft} from "@/modules/CarList/interfaces/anti-theft.interface";
  import {httpResource} from "@/resources/http.resource";
  import {IApp} from "@/interfaces/app.interface";
  import _ from 'lodash';
  import {AntiTheftActions} from "@/modules/CarList/mixins/anti-theft-actions.mixin";
  import {KeyboardMobileHidden} from "@/plugins/keyboard-mobile-hidden";
  import moment from "moment";
  import ScheduleTimesBlock from "@/modules/CarList/components/AntiTheftComponents/ScheduleTimesBlock.vue";
  import {ICar} from "@/modules/Car/interfaces/car.interface";
  import {IAppState} from "@/interfaces/app-state.interface";

  @Component({
    components: {
      AppSwitch,
      ScheduleTimesBlock,
    }
  })
  export default class CarAntiTheft extends Vue {

    scheduleActive = false;
    securityActive = false;
    theftScheduleActive = false;
    hasProblem = false;
    defaultSchedule: IAntiTheft.IScheduleItem[] = null;
    schedule: IAntiTheft.IScheduleItem[] = null;
    weekDays = ['пн','вт','ср','чт','пт','сб','вс'];
    activeCar: IAntiTheft.IStatusCars = null;
    invalidRows = [];

    get storeState(): IAppState { return this.$store.state; }
    get popupCar(): ICar.IEntity { return this.storeState.car.activeCar; }
    get hasChanges() { return !_(this.defaultSchedule).differenceWith(this.schedule, _.isEqual).isEmpty(); }
    get printStatusSecurity() {
      let result = '';
      if (this.securityActive) {
        result = 'Стоит на охране';
      }
      else {
        if (this.theftScheduleActive) result = 'Охрана по расписанию';
        else result = 'Выезд разрешен';
      }
      return result;
    }

    async getSchedule() {
      let asyncAction = async () => {
        const action = IAntiTheft.Action;
        const params: any = {
          command: IAntiTheft.Command.GetSchedule,
          carId: this.popupCar.carId,
        };
        const {data: {result: response }} = await httpResource.httpAction({ action, params });
        this.schedule = response.sort((a, b) => a.day >= b.day ? 1 : -1);
        this.defaultSchedule = _.cloneDeep(this.schedule);
      };

      await this.$store.dispatch('defaultResourceAction', { asyncAction });
    }

    presetFlagsFromServer(car: IAntiTheft.IStatusCars) {
      this.activeCar = car;
      this.securityActive = car.theftFlag;
      this.scheduleActive = car.theftScheduleFlag;
      this.hasProblem = car.problemFlag;
      this.theftScheduleActive = car.theftScheduleActive;
    }

    async getCarStatus() {
      let searchedCars: IAntiTheft.IStatusCars[] = await AntiTheftActions.getCarsStatuses(this, this.popupCar.carId);
      let searchedCar = searchedCars.find((item: IAntiTheft.IStatusCars) => item.carId === this.popupCar.carId);
      if (searchedCar) this.presetFlagsFromServer(searchedCar);
    }

    async changeStatus(flagName: string) {
      this[flagName] = !this[flagName];
      let { response: { data: { result: carData }}} = await AntiTheftActions.changeStatus(this, {
        carId: this.popupCar.carId,
        securityActive: this.securityActive,
        scheduleActive: this.scheduleActive,
      });
      this.presetFlagsFromServer(carData);
    }

    async saveAllSchedules() {
      this.saveSchedule();
      this.defaultSchedule = _.cloneDeep(this.schedule);

      this.$notify({
        title: 'Успешно',
        message: 'Данные успешно сохранены',
        type: 'success'
      });
    }

    async saveSchedule() {
      let asyncAction = async () => {
        const action = IAntiTheft.Action;
        const params: any = {
          command: IAntiTheft.Command.SetSchedule,
          carId: this.popupCar.carId,
          theftSchedule: this.schedule,
        };
        await httpResource.httpAction({ action, params });
      };

      await this.$store.dispatch('defaultResourceAction', { asyncAction });
    }

    activateScheduleRow(schedule: IAntiTheft.IScheduleItem, times: string[][], index: number) {
      Vue.set(this.schedule[index], 'times', times);

      let enabled = Boolean(schedule.times[0][0]) && Boolean(schedule.times[0][1]);
      Vue.set(this.schedule[index], 'enabled', enabled);

      this.checkScheduleToErrors(schedule, index);
    }

    clearChanges() {
      this.schedule = _.cloneDeep(this.defaultSchedule);
      this.invalidRows = [];
    }

    copyOnNextDay(indexRow: number) {
      let nextIndex = indexRow === this.schedule.length - 1 ? 0 : indexRow + 1;
      Vue.set(this.schedule, nextIndex, {
        ...this.schedule[nextIndex],
        times:  _.cloneDeep(this.schedule[indexRow].times),
        enabled: this.schedule[indexRow].enabled,
      });
    }

    async prepareData() {
      if (!this.schedule) {
        await this.getCarStatus();
        await this.getSchedule();
      }
      KeyboardMobileHidden();
    }

    clearDate(index: number, timeI: number, timeJ: number) {
      if (!this.scheduleActive) return;

      Vue.set(this.schedule[index].times[timeI], timeJ, '');
    }

    printDayTo(schedule: IAntiTheft.IScheduleItem, dayNumber: number) {
      let printText = [];
      schedule.times.forEach((times, i) => {
        printText[i] = '';
        if (times[0] && times[1]) {
          let start = moment(times[0], IApp.DateFormats.TimeFull).format('x');
          let end = moment(times[1], IApp.DateFormats.TimeFull).format('x');

          if (end < start) {
            printText[i] = this.weekDays[dayNumber === this.schedule.length - 1 ? 0 : dayNumber + 1];
          }
        }
      });

      return printText.map(item => item.toUpperCase());
    }

    checkAllRows() {
      this.schedule.forEach((row, index) => {
        this.checkScheduleToErrors(row, index);
      });
    }

    checkScheduleToErrors(schedule: IAntiTheft.IScheduleItem, index: number) {
      let nextIndex = index === this.schedule.length - 1 ? 0 : index + 1;
      let prevIndex = index === 0 ? this.schedule.length - 1 : index - 1;
      let currentEnabled = schedule.enabled;
      let prevEnabled = this.schedule[prevIndex].enabled;
      let nextEnabled = this.schedule[nextIndex].enabled;
      let hasError = false;

      let printDayTo = this.printDayTo(this.schedule[prevIndex], prevIndex);
      let lastDayIndex = printDayTo.findIndex(item => item != '');
      if (lastDayIndex != -1 && currentEnabled && prevEnabled) {
        let prevTimeEnd = moment(this.schedule[prevIndex].times[lastDayIndex][1], IApp.DateFormats.TimeFull).format('x');
        let currentTimeStart = moment(schedule.times[0][0], IApp.DateFormats.TimeFull).format('x');
        if (currentTimeStart <= prevTimeEnd) {
          let indexExisting = this.invalidRows.indexOf(index);
          if (indexExisting === -1) {
            this.invalidRows.push(index);
          }
          hasError = true;
        }
        else {
          let prevIndexError = this.invalidRows.indexOf(prevIndex);
          if (prevIndexError !== -1) {
            this.invalidRows.splice(prevIndexError, 1);
          }
        }
      }

      printDayTo = this.printDayTo(this.schedule[index], prevIndex);
      lastDayIndex = printDayTo.findIndex(item => item != '');
      if (lastDayIndex != -1 && currentEnabled && nextEnabled) {
        if (this.schedule[nextIndex].times[0][0] && schedule.times[0][1]) {
          let nextTimeStart = moment(this.schedule[nextIndex].times[0][0], IApp.DateFormats.TimeFull).format('x');
          let currentTimeEnd = moment(schedule.times[lastDayIndex][1], IApp.DateFormats.TimeFull).format('x');
          if (currentTimeEnd >= nextTimeStart) {
            let indexExisting = this.invalidRows.indexOf(index);
            if (indexExisting === -1) {
              this.invalidRows.push(index);
            }
            hasError = true;
          }
        }
      }

      if (!hasError || !currentEnabled) {
        let indexDeleted = this.invalidRows.indexOf(index);
        if (indexDeleted !== -1) {
          this.invalidRows.splice(indexDeleted, 1);
        }
      }
    }
  }
